import React, { FC } from "react";
import { GroupBlockEntityType } from "../../../../configMap";
import Loader from "../../../../common/loader/Loader";
import HoverButtonsWrapper from "../entityCell/entityAnnotation/HoverButtons/HoverButtonsWrapper";
import EntityPercentage from "../../../../configMap/components/entity/EntityPercentage";
import { EntityAnnotation } from "../../../../annotation";
import InvalidIcon from "./entityAnnotation/InvalidIcon";
import EntitySwitch from "../../../../common/entityComponents/components/EntitySwitch";
import useIsEntityRequiredEmpty from "../../../../metadata/hooks/useIsEntityRequiredEmpty";

type EntityProps = {
  activeDocumentId?: string;
  annotationForEntity: EntityAnnotation;
  isEditing: string | null;
  editingKey: string;
  isAnnotating: boolean;
  removeAnnotation: (annotationId: string) => void;
  isAnnotationLoading?: boolean;
  groupBlockEntityType: GroupBlockEntityType;
  groupBlockIndex: number;
  disabled: boolean;
  requiresAttention: boolean;
  isFirstAnnotation?: boolean;
  isEditable: boolean;
  modelScore: number;
  cellClasses: string;
  isCellWidthDefined: boolean;
};

const CellRow: FC<EntityProps> = ({
  activeDocumentId,
  annotationForEntity,
  isEditing,
  editingKey,
  isAnnotating,
  removeAnnotation,
  isAnnotationLoading,
  groupBlockEntityType,
  groupBlockIndex,
  disabled,
  requiresAttention,
  isFirstAnnotation = true,
  isEditable,
  modelScore,
  cellClasses,
  isCellWidthDefined,
}) => {
  const isRequiredEmpty = useIsEntityRequiredEmpty(
    groupBlockEntityType,
    groupBlockIndex,
  );

  const showRequiredBorder = isRequiredEmpty && isEditing !== editingKey;

  return (
    <div
      className={`list-item-description${
        showRequiredBorder ? " is-required-empty" : ""
      }`}
    >
      <EntitySwitch
        documentId={activeDocumentId}
        entityType={groupBlockEntityType}
        entityAnnotation={annotationForEntity}
        isEditing={isEditable && isEditing === editingKey}
        isAnnotating={isAnnotating}
        groupBlockIndex={groupBlockIndex}
        disabled={disabled}
        cellClasses={cellClasses}
        isTableMode={true}
      />
      <HoverButtonsWrapper
        isEditing={isEditing === editingKey}
        entityAnnotation={annotationForEntity}
        removeAnnotation={removeAnnotation}
        disabled={disabled}
      />
      {isCellWidthDefined && isFirstAnnotation && !isAnnotationLoading ? (
        <>
          <EntityPercentage
            requiresAttention={requiresAttention}
            isEditing={isEditing === editingKey}
            modelScore={modelScore}
          />
          <InvalidIcon cellClasses={cellClasses} />
        </>
      ) : null}
      {isAnnotationLoading ? (
        <div className="loader">
          <Loader size="small" />
        </div>
      ) : null}
    </div>
  );
};

export default CellRow;
